/*!
 * Judge.me レビューウィジェット — 表示カスタマイズ（casucahada）
 *
 * 用途:
 *   ① 「購入経路: MIC OFFICIAL FITTER」の行を消し、投稿者アイコンの横にバッジ画像を出す
 *      （BADGE_POSITION = 'inline' にすれば、元の行の位置でバッジに差し替えもできる）
 *   ② 指定した項目の行にクラスを付けて余白を調整する
 *      （既定: 「再購入・おすすめ度」の下に余白）
 *
 * 設置場所: Shopify テーマの Assets に judgeme-replace-text.js として置き、
 *           theme.liquid の </body> 直前で読み込む。
 *           <script src="{{ 'judgeme-replace-text.js' | asset_url }}" defer></script>
 *
 * 注意: Judge.me はレビューを非同期で描画し、ページ送り・絞り込みのたびに
 *       DOM を作り直すため、MutationObserver で再適用している。
 */
(function () {
  'use strict';

  /* ===== 設定 ================================================== */

  // 目印にする文字列。全角コロン「：」や余分な空白・改行は自動で吸収する。
  var TARGET = '購入経路: MIC OFFICIAL FITTTER';

  // バッジの表示位置
  //   'header' : 投稿者アイコンの横に出す（元の行は非表示にする）
  //   'inline' : 元の「購入経路」の行をそのままバッジに置き換える
  var BADGE_POSITION = 'header';

  // バッジ画像
  var BADGE_SRC =
    'https://cdn.shopify.com/s/files/1/0769/6180/8691/files/officialfitter.png?v=1789367422';
  var BADGE_ALT = 'MIC OFFICIAL FITTER';

  // バッジのスタイル（大きさは height の数値で調整する）
  var BADGE_CSS =
    '.mic-fitter-badge{width:auto;vertical-align:middle;display:inline-block}' +
    '.mic-fitter-badge--header{height:36px;margin-right:.6em}' +
    '.mic-fitter-badge--inline{height:36px}';

  // 1件のレビュー全体を指すセレクタ（上から順に試す）
  var REVIEW_SELECTORS = ['.jdgm-rev', '[class*="jdgm-rev"]'];

  // バッジを差し込む位置（上から順に試す）
  //   mode 'before' : その要素の直前に置く
  //   mode 'after'  : その要素の直後に置く
  //   mode 'append' : その要素の末尾に追加する
  // ここで見つからない場合は、下の findAnchor() がクラス名に頼らずに探す。
  var BADGE_ANCHORS = [
    { sel: '.jdgm-rev__author', mode: 'before' },     // 投稿者名の直前＝人マークのアイコンの横
    { sel: '.jdgm-rev__icon', mode: 'after' },        // 人マークのアイコン
    { sel: '.jdgm-rev__avatar', mode: 'after' },
    { sel: '.jdgm-rev__buyer-badge', mode: 'before' },// 「認証済み」バッジ
    { sel: '.jdgm-rev__header', mode: 'append' }      // 投稿者情報の行
  ];

  // 差し込み先が見つからない経緯をコンソールに出す（設置後の切り分け用。通常は true のままでよい）
  var DEBUG = true;

  // 特定の行にクラスを付ける設定。labels は行頭一致（全角/半角コロン両対応）。
  var ROW_STYLES = [
    // 「再購入・おすすめ度」の行の下に余白を入れる
    { labels: ['再購入・おすすめ度'], className: 'mic-rev-space-after' }
  ];

  // 上記クラスのスタイル
  var ROW_CSS =
    '.mic-rev-space-after{padding-bottom:2em;}';

  // ウィジェットのルート要素。該当しなければ document 全体を走査する。
  var ROOT_SELECTOR = '.jdgm-widget, #judgeme_product_reviews, .jdgm-all-reviews-widget';

  /* ============================================================= */

  var FLAG = 'data-mic-replaced';
  var ROW_FLAG = 'data-mic-row';

  // 空白と全角/半角コロンの揺れを吸収した比較用の文字列
  function norm(s) {
    return String(s).replace(/：/g, ':').replace(/\s+/g, ' ').trim();
  }
  var TARGET_N = norm(TARGET);

  function makeBadge(variant) {
    var img = document.createElement('img');
    img.className = 'mic-fitter-badge mic-fitter-badge--' + variant;
    img.src = BADGE_SRC;
    img.alt = BADGE_ALT;
    img.loading = 'lazy';
    return img;
  }

  function injectCss() {
    if (document.getElementById('mic-rev-css')) return;
    var style = document.createElement('style');
    style.id = 'mic-rev-css';
    style.textContent = BADGE_CSS + ROW_CSS;
    document.head.appendChild(style);
  }

  function eachRoot(fn) {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    if (roots.length) {
      Array.prototype.forEach.call(roots, fn);
    } else {
      fn(document.body);
    }
  }

  // el の祖先から「1件のレビュー」にあたる要素を探す
  function findReview(el) {
    for (var i = 0; i < REVIEW_SELECTORS.length; i++) {
      var hit = el.closest(REVIEW_SELECTORS[i]);
      if (hit) return hit;
    }
    return null;
  }

  // 差し込み先を探す。まず既知のクラス名、なければ構造から推測する。
  function findAnchor(review) {
    var i, hit;

    // 1) 既知のクラス名
    for (i = 0; i < BADGE_ANCHORS.length; i++) {
      hit = review.querySelector(BADGE_ANCHORS[i].sel);
      if (hit) return { el: hit, mode: BADGE_ANCHORS[i].mode, how: BADGE_ANCHORS[i].sel };
    }

    // 2) クラス名に author / avatar / icon を含む要素
    var guesses = [
      { sel: '[class*="author"]', mode: 'before' },
      { sel: '[class*="avatar"]', mode: 'after' },
      { sel: '[class*="icon"]', mode: 'after' }
    ];
    for (i = 0; i < guesses.length; i++) {
      hit = review.querySelector(guesses[i].sel);
      if (hit) return { el: hit, mode: guesses[i].mode, how: guesses[i].sel };
    }

    // 3) レビュー内の最初の画像（＝投稿者アイコンとみなす）。自分のバッジは除外。
    hit = review.querySelector('img:not(.mic-fitter-badge), svg');
    if (hit) return { el: hit, mode: 'after', how: 'first img/svg' };

    // 4) 最後の手段：レビューの先頭ブロックの末尾に追加
    if (review.firstElementChild) {
      return { el: review.firstElementChild, mode: 'append', how: 'first child' };
    }
    return null;
  }

  // レビュー内の投稿者アイコン付近にバッジを差し込む
  function placeBadgeInHeader(review) {
    if (review.querySelector('.mic-fitter-badge')) return true; // 既に入っている

    var anchor = findAnchor(review);
    if (!anchor) return false;

    if (anchor.mode === 'append') {
      anchor.el.appendChild(makeBadge('header'));
    } else if (anchor.mode === 'before') {
      anchor.el.insertAdjacentElement('beforebegin', makeBadge('header'));
    } else {
      anchor.el.insertAdjacentElement('afterend', makeBadge('header'));
    }
    if (DEBUG) console.info('[mic] バッジの差し込み先:', anchor.how, anchor.el);
    return true;
  }

  /* ----- 「購入経路: MIC OFFICIAL FITTER」の行を処理する ----- */

  function handleTargetRows(root) {
    if (!root) return;
    var els = root.querySelectorAll('*');

    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.hasAttribute(FLAG)) continue;
      if (norm(el.textContent).indexOf(TARGET_N) === -1) continue;

      // より内側に一致する要素があるなら、そちらに任せる（行の要素だけを対象にする）
      var hasInnerMatch = false;
      for (var j = 0; j < el.children.length; j++) {
        if (norm(el.children[j].textContent).indexOf(TARGET_N) !== -1) {
          hasInnerMatch = true;
          break;
        }
      }
      if (hasInnerMatch) continue;

      // 行の中身が対象文字列だけでない＝他の回答も同居している場合は触らない
      if (norm(el.textContent) !== TARGET_N) {
        console.warn('[mic] 対象の行に他の文字列が含まれるため処理を見送りました:', el);
        continue;
      }

      el.setAttribute(FLAG, '');

      if (BADGE_POSITION === 'inline') {
        el.innerHTML = '';
        el.appendChild(makeBadge('inline'));
        continue;
      }

      // BADGE_POSITION === 'header'
      var review = findReview(el);
      if (review && placeBadgeInHeader(review)) {
        el.style.display = 'none'; // 元の行は隠す
      } else {
        // 差し込み先が見つからないときは、その場でバッジに置き換えて表示は保つ
        console.warn('[mic] レビュー要素または差し込み先が見つからないため、' +
          'その場にバッジを表示しました。REVIEW_SELECTORS の見直しが必要です:', el);
        el.innerHTML = '';
        el.appendChild(makeBadge('inline'));
      }
    }
  }

  /* ----- 指定ラベルの行にクラスを付ける ----- */

  var rowRules = ROW_STYLES.map(function (rule) {
    return {
      className: rule.className,
      res: rule.labels.map(function (label) {
        return new RegExp('^' + label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*[:：]');
      })
    };
  });

  function matches(res, text) {
    return res.some(function (re) { return re.test(text); });
  }

  function styleRows(root) {
    if (!root || !rowRules.length) return;
    var els = root.querySelectorAll('*');

    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.hasAttribute(ROW_FLAG)) continue;

      var text = norm(el.textContent);

      for (var r = 0; r < rowRules.length; r++) {
        var rule = rowRules[r];
        if (!matches(rule.res, text)) continue;

        // より内側に一致する要素があるなら、そちらに任せる（行の要素だけに付ける）
        var hasInnerMatch = false;
        for (var j = 0; j < el.children.length; j++) {
          if (matches(rule.res, norm(el.children[j].textContent))) {
            hasInnerMatch = true;
            break;
          }
        }
        if (hasInnerMatch) continue;

        el.setAttribute(ROW_FLAG, '');
        el.classList.add(rule.className);
      }
    }
  }

  /* ----- 実行 ----- */

  var timer = null;
  var observer = null;

  function run() {
    if (observer) observer.disconnect(); // 自分の書き換えで再発火しないよう一時停止
    injectCss();
    eachRoot(function (root) {
      handleTargetRows(root);
      styleRows(root);
    });
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 100); // 連続する DOM 変更をまとめる
  }

  function init() {
    run();
    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();